<template>
  <section class="mx-4.5 py-5 md:py-12" data-testid="tradeable-futures">
    <div class="mx-auto w-full max-w-content-container">
      <div class="mx-auto items-center gap-x-12 md:flex lg:w-10/12">
        <div class="md:w-1/2">
          <h2 class="mb-6 text-h4 md:text-h3"> What You Can Trade on ICE: </h2>
          <div class="yellow-bullet text-paragraph-xl md:text-paragraph-xxl">
            <slot />
          </div>
          <p class="max-w-[29.25rem] py-6 text-h7 md:text-h6">
            {{ legend }}
          </p>
          <ButtonContactUs class="w-full md:w-fit" text="Contact Us" />
        </div>

        <div class="hidden md:block md:w-1/2">
          <img
            class="aspect-[568/319] rounded-xl bg-black/10"
            alt="A laptop displaying financial charts and data analytics on its screen, set against a blurred background with warm bokeh lighting"
            :src="imageUrl"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import ButtonContactUs from '~/components/shared/common/ButtonContactUs.vue'

defineProps<{
  legend: string
  imageUrl: string
}>()
</script>

<style>
.yellow-bullet ul {
  list-style: none;
  list-style-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA4YTQgNCAwIDEgMCAwLTggNCA0IDAgMCAwIDAgOFoiIGZpbGw9IiNFMTg4MDAiLz48L3N2Zz4=');

  @apply flex flex-col gap-y-8 pl-4;
}
</style>
